<template lang="pug">
	dx-validation-group.station-detail.flex-col.space.full-width.full-height(v-if="($auth.isStationOwner() && $auth.isDirector()) || $auth.isAdmin()")
		Loader(v-if="isLoading && !station", :fullscreen="true")
		template(v-if="station")
			.flex-col.space-large
				.full-height.flex-2.station-map
					CartoMap.station-map(ref="map",
						:layers="layers",
						:geoJsonStyle="{ fillColor: '#f27649', fillOpacity: 0.1, color: '#f27649', colorOpacity: 0.3, weight: 1 }",
						:showFilters="true",
						:filters="['circle']",
						:searchPlaceEnabled="true",
						:circleDrawings="circleDrawings",
						@place-changed="onPlaceChanged",
						@filter-changed="onFilterChanged",
						@built="setStationLatLng"
					)
				.flex-row.wrap.buttons-group
					.button-item
						DxButton(:text="$tCaption('Station info')", stylingMode="text", @click="page = 'main'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="page === 'main' ? 'default' : 'normal'")
					template(v-if="isStored")
						.button-item
							DxButton(:text="$tCaption('Streaming and logging')", stylingMode="text", @click="page = 'streaming-and-logging'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="page === 'streaming-and-logging' ? 'default' : 'normal'")
						.button-item(v-if="id")
							DxButton(:text="$tCaption('Streaming encoders')", stylingMode="text", @click="page = 'streaming-encoders'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="page === 'streaming-encoders' ? 'default' : 'normal'")
						.button-item(v-if="id")
							DxButton(:text="$tCaption('Ai Disclosure')", stylingMode="text", @click="page = 'ai-disclosure'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="page === 'ai-disclosure' ? 'default' : 'normal'")
						.button-item(v-if="id")
							DxButton(:text="$tCaption('Raspberry Pi')", stylingMode="text", @click="page = 'raspberry-pi'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="page === 'raspberry-pi' ? 'default' : 'normal'")
				StreamingEncodersList(v-if="page === 'streaming-encoders' && id", :stationId="id", :allowEdit="allowEdit")
				.flex-col.lr-padding.space(v-if="page === 'ai-disclosure'")
					template(v-if="disclosure")
						.flex-row.space-large
							.flex-col.space
								.font-small.upper.grey {{$tCaption('Url')}}
								span {{disclosure.Url}}
							.flex-col.space
								.font-small.upper.grey {{$tCaption('Status')}}
								.disclosure-status(:class="{ approved: disclosure.Approved }") {{disclosure.Approved ? $tCaption('Approved') : $tCaption('Uploaded')}}
						.flex-row
							img.disclosure-image(:src="disclosureImage")
					Loader(v-else-if="isLoading")
					.flex-row(v-if="allowEdit && disclosureLoaded && (!disclosure || !disclosure.Approved)")
						DxButton(:text="$tCaption('Upload screenshot')", @click="showDisclosure")
				.flex-col.lr-padding.space(v-if="page === 'streaming-and-logging'")
					.flex-row.space.wrap
						.flex-row.flex-1.space-large.station-block
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Streaming name')}}
								DxTextBox(v-model="station.StreamingName", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Streaming description')}}
								DxTextBox(v-model="station.StreamingDescription", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Streaming genre')}}
								DxTextBox(v-model="station.StreamingGenre", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Streaming url')}}
								DxTextBox(v-model="station.StreamingUrl", :disabled="!allowEdit")
							.flex-col.center
								DxCheckBox(:value.sync="station.ImportStreamingLogs", :text="$tCaption('Import streaming logs')", :disabled="!allowEdit")
							.save.flex-row.right.align-center.ml-auto
								DxButton(
									v-if="station && allowEdit && !saveButtonHidden",
									type="success",
									:text="$tCaption('Save', '@actions')",
									icon="fas fa-check",
									@click="save",
									:disabled="isSaving || isLoading || !dataChanged"
								)
								Loader(v-if="isSaving", :text="''")
				.flex-col.lr-padding.space(v-if="page === 'raspberry-pi'")
					template(v-if="isLinkedComputerLoaded")
						StationComputerDetail(v-if="linkedComputer", :record="linkedComputer")
						.flex-row.space(v-else)
							DxButton(:text="$tCaption('Add computer')", @click="showLinkedComputersSelector")
					Popup(v-if="linkedComputerPopupVisible", :popupVisible.sync="linkedComputerPopupVisible", :width="340", :height="440", :title="$tCaption('Available computers')")
						ListView(:columns="linkedComputerColumns", :searchVisible="false", :hideViewsSelection="true", initialView="table", :showColumnHeaders="false", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", 
							:getData="getEmptyComputers", @selection="items => selectedComputer = items[0]", :height="240", selectionMode="single", :bottomPagerVisible="false")
						template(slot="actions-right")
							DxButton(:text="$tCaption('Close', '@actions')", @click="linkedComputerPopupVisible = false")
							DxButton(:text="$tCaption('Link', '@actions')", icon="check" type="success", @click="linkSelectedComputer", :disabled="!selectedComputer")
				.flex-col.lr-padding.space(v-if="page === 'main'")
					.flex-row.space.station-block.justify
						.flex-row.space.align-start
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Radius')}}
								DxNumberBox(v-model="station.Radius", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Latitude')}}
								DxNumberBox(v-model="station.Latitude", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Longitude')}}
								DxNumberBox(v-model="station.Longtitde", :disabled="!allowEdit")
						.save.flex-row.center.align-center
							DxButton(
								v-if="station && allowEdit && !saveButtonHidden",
								type="success",
								:text="$tCaption('Save', '@actions')",
								icon="fas fa-check",
								@click="save",
								:disabled="isSaving || isLoading || !dataChanged"
							)
							Loader(v-if="isSaving", :text="''")
					.flex-row.space.wrap
						.flex-col.flex-1.space-large.station-block.flex-basis-200
							.flex-col.space.align-center(v-if="station && station.Oid")
								img.station-image(v-if="logoUrl", :src="logoUrl")
								FileUploader(v-if="allowEdit", :text="$tCaption('Upload logo')", icon="fas fa-cloud-upload-alt", @upload="onPhotoChange", :popupConfig="{ height: 520, width: 520 }")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Name')}}
								DxTextBox(v-model="station.Name", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Description')}}
								DxTextArea(v-model="station.Description", :height="60", width="100%", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('CallLetters')}}
								DxTextBox(v-model="station.CallLetters", :disabled="!allowEdit")
									dx-validator
										dx-custom-rule(:validation-callback="() => station.CallLetters", :message="$tCaption('You must enter call letters')")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Slogan')}}
								DxTextBox(v-model="station.Slogan", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('FccId')}}
								DxTextBox(v-model="station.FccId", :disabled="!allowEdit")
						.flex-col.flex-1.space-large.station-block.flex-basis-200
							DxCheckBox(:value.sync="station.Educational", :text="$tCaption('Educational')", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Ethnicity')}}
								DxSelectBox(:items="ethnicityTypes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="station.Ethnicity", :disabled="!allowEdit")
							.flex-col.field
								.flex-row.justify
									.font-small.upper.grey {{$tCaption('Male')}} ({{station.Male || 0}}%)
									.font-small.upper.grey {{$tCaption('Female')}} ({{100 - (station.Male || 0)}}%)
								DxSlider(v-model="station.Male", :min="0", :max="100", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Age')}}
								DxNumberBox(v-model="station.Age", :min="0", :max="120", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Phone')}}
								DxTextBox(v-model="station.Phone", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Website')}}
								DxTextBox(v-model="station.Website", :disabled="!allowEdit")
						.flex-col.flex-1.space-large.station-block.flex-basis-200
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Market size')}}
								Dropdown(ref="marketSizeDD", :getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="getMarketSizes",
									:columns="[{ dataField: 'Name', caption: $tCaption('Market size') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:placeholder="$tCaption('Market size')",
									:disabled="!allowEdit",
									:selectedItems="station.MarketSize && station.MarketSize.Oid",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="false",
									@select-data="item => station.MarketSize = item")
									dx-validator
										dx-custom-rule(:validation-callback="() => station.MarketSize && station.MarketSize.Oid", :message="$tCaption('You must select market size')")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Country')}}
								Dropdown(ref="countryDD", :getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="$Data.getExternalCountries",
									:columns="[{ dataField: 'Name', caption: $tCaption('Country') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:placeholder="$tCaption('Country')",
									:disabled="true",
									:selectedItems="station.Country && station.Country.Oid",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="false",
									@select-data="item => station.Country = item")
							.flex-col.field(v-if="station.Country && station.Country.Oid")
								.font-small.upper.grey {{$tCaption('CountryRegion')}}
								Dropdown(:getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalCountryRegions(a,b,c,station.Country.Oid)",
									:columns="[{ dataField: 'Name', caption: $tCaption('Region') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:placeholder="$tCaption('Region')",
									:disabled="!allowEdit",
									:selectedItems="station.CountryRegion && station.CountryRegion.Oid",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="false",
									@select-data="item => station.CountryRegion = item")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('County')}}
								DxTextBox(v-model="station.County", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Station band')}}
								DxSelectBox(:items="bandTypes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="station.StationBand", :disabled="!allowEdit")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Frequency')}}
								DxNumberBox(v-model="station.Frequency")
						.flex-col.flex-1.space-large.station-block.flex-basis-200
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Zone')}}
								Dropdown(ref="zoneDD", :getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalZones(a,b,c, 0)",
									:columns="[{ dataField: 'Name', caption: $tCaption('Zone') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:placeholder="$tCaption('Zone')",
									:disabled="!allowEdit",
									:selectedItems="station.Zone && station.Zone.Oid",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="false",
									@select-data="item => station.Zone = item ? { Oid: item.Oid } : null")
							.flex-col.field(v-if="$getSetting('custom.nielsenDma.visible') !== false")
								.font-small.upper.grey {{$getSetting('custom.nielsenDma.caption') || $tCaption('DMA Zone')}}
								Dropdown(ref="dmaZoneDD", :getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalZones(a,b,c, 2)",
									:columns="[{ dataField: 'Name', caption: $getSetting('custom.nielsenDma.caption') || $tCaption('DMA Zone') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:disabled="!allowEdit",
									:placeholder="$getSetting('custom.nielsenDma.caption') || $tCaption('DMA Zone')",
									:selectedItems="station.DmaZone && station.DmaZone.Oid",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="false",
									@select-data="item => station.DmaZone = item ? { Oid: item.Oid } : null")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Msa Zone')}}
								Dropdown(:getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalZones(a,b,c, 1)",
									:columns="[{ dataField: 'Name', caption: $tCaption('Msa Zone') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:placeholder="$tCaption('Msa Zone')",
									:disabled="!allowEdit",
									:selectedItems="station.MsaZone && station.MsaZone.Oid",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="false",
									@select-data="item => station.MsaZone = item ? { Oid: item.Oid } : null")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Network')}}
								Dropdown(:getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="$Data.getExternalNetworks",
									:columns="[{ dataField: 'Name', caption: $tCaption('Network') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:placeholder="$tCaption('Network')",
									:disabled="!allowEdit",
									:selectedItems="station.Network && station.Network.Oid",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="false",
									@select-data="item => station.Network = item ? { Oid: item.Oid } : null")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Secondary network')}}
								Dropdown(:getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="$Data.getExternalNetworks",
									:columns="[{ dataField: 'Name', caption: $tCaption('Secondary network') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:placeholder="$tCaption('Secondary network')",
									:disabled="!allowEdit",
									:selectedItems="station.SecondaryNetwork && station.SecondaryNetwork.Oid",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="false",
									@select-data="item => station.SecondaryNetwork = item ? { Oid: item.Oid } : null")
							.flex-col.field
								.font-small.upper.grey {{$tCaption('Formats')}}
								Dropdown(:getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="$Data.getExternalStationFormats",
									:columns="[{ dataField: 'Name', caption: $tCaption('Formats') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:placeholder="$tCaption('Formats')",
									:disabled="!allowEdit",
									:selectedItems="station.Formats && station.Formats.map(f => f.Oid)",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="true",
									@select-data="items => station.Formats = items")
		FileUploader(ref="disclosureUploader", v-if="page === 'ai-disclosure'", :text="$tCaption('Upload Ai Disclosure')", :isUIHidden="true", @upload="onDisclosureChange", :popupConfig="{ height: 280, width: 720 }")
			.flex-col.space(slot="top-content")
				.flex-col.field
					.font-small.upper.grey {{$tCaption('URL')}}
					DxTextBox(:value.sync="disclosureUrl")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import Loader from 'app-core/Loader.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import CartoMap from 'view/carto/CartoMapComponent.vue';
	import DxTextArea from 'devextreme-vue/text-area';
	import { DxCheckBox } from 'devextreme-vue/check-box';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import { DxSlider } from 'devextreme-vue/slider';
	import StreamingEncodersList from './StreamingEncodersList.vue';
	import FileUploader from 'app-core/FileUploader.vue';
	import Popup from 'app-core/Popup.vue';
	import ListView from 'app-core/ListView.vue';
	import StationComputerDetail from './StationComputerDetail.vue';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';

	export default {
		translationCategory: 'station.Detail',
		name: 'station-detail',
		components: {
			DxButton, DxTextBox, Loader, DxDateBox, Dropdown, CartoMap, DxTextArea, DxCheckBox, DxSelectBox, DxNumberBox, DxSlider, StreamingEncodersList, FileUploader, Popup, ListView,
			StationComputerDetail, DxValidationGroup, DxValidator, DxRequiredRule, DxCustomRule
		},
		props: ['id', 'preventRedirect', 'saveButtonHidden'],
		data() {
			return {
				station: null,
				isLoading: false,
				isSaving: false,
				tab: 'creatives',
				layers: [{
					query: null,
					customStyle: `
						#layer[zoom>3] {
							polygon-fill: #f27649;
							polygon-opacity: 0.025;
						}
						#layer::outline[zoom>8] {
							line-width: 1;
							line-color: #f27649;
							line-opacity: 0.2;
						}
						#layer::labels[zoom>8] {
							text-name: [station];
							text-face-name: 'DejaVu Sans Book';
							text-size: 10;
							text-fill: #FFFFFF;
							text-label-position-tolerance: 0;
							text-halo-radius: 2;
							text-halo-fill: #f27649;
							text-dy: -10;
							text-allow-overlap: false;
							text-placement: point;
							text-placement-type: dummy;
						}
					`,
					click: null
				}],
				circleDrawings: [],
				dataChanged: false,
				page: 'main',
				logoUrl: null,
				disclosure: null,
				disclosureUrl: null,
				disclosureLoaded: false,
				linkedComputer: null,
				isLinkedComputerLoaded: false,
				linkedComputerPopupVisible: false,
				linkedComputerColumns: [{ dataField: 'ComputerNumber' }],
				selectedComputer: null
			};
		},
		computed: {
            bandTypes() {
                return [
                    {id: 0, name: this.$tCaption('FM')},
                    {id: 1, name: this.$tCaption('AM')},
                    {id: 2, name: this.$tCaption('LP')},
                    {id: 3, name: this.$tCaption('DAB')},
                    {id: 4, name: this.$tCaption('HD')},
                    {id: 5, name: this.$tCaption('DRM')},
                    {id: 6, name: this.$tCaption('Stream')},
                    {id: 7, name: this.$tCaption('Podcast')},
                    {id: 8, name: this.$tCaption('Instore')},
                    {id: 9, name: this.$tCaption('Pos')},
                ]
            },
            ethnicityTypes() {
                return [
                    {id: 0, name: this.$tCaption('Unknown')},
                    {id: 1, name: this.$tCaption('Hispanic')},
                    {id: 2, name: this.$tCaption('Black')},
                    {id: 3, name: this.$tCaption('Asian')},
                    {id: 4, name: this.$tCaption('White')},
                    {id: 5, name: this.$tCaption('DRM')},
                    {id: 6, name: this.$tCaption('NativeHawaiianOrOtherPacificIslander')},
                ]
            },
            allowEdit() {
				return (this.$auth.isStationOwner() && this.$auth.isDirector()) || this.$auth.isAdmin();
			},
			disclosureImage() {
				var data = this.disclosure?.Screenshot?.Base64Content;
				return data && `data:image;base64,${data}`;
			},
			isStored() {
				return !!this.station?.Oid;
			}
		},
		watch: {
			station: {
				handler() {
					if (!this.isLoading && !this.isSaving) {
						this.dataChanged = true;
					}
				},
				deep: true
			},
			id(v) {
				if (v === 'new') {
					this.setNew();
				} else if (!this.station || this.station.Oid !== v) {
					this.loadData();
				}
			},
			'station.Latitude'() {
				this.setStationLatLng();
			},
			'station.Longtitude'() {
				this.setStationLatLng();
			},
			'station.Radius'() {
				this.setStationLatLng();
			},
			page(v) {
				switch (v) {
					case 'ai-disclosure':
						this.loadDisclosure();
						break;
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.stationDetail = this;
			this.loadData();
			this.loadLinkedComputer();
		},
		beforeRouteLeave(to, from, next) {
			if (this.isSaving || this.isLoading) {
				next(false);
				this.$notifyError(this.$tCaption('Station is busy, please wait!'));
			}
			if (this.dataChanged) {
				this.$confirmMessage({
					title: this.$tCaption('Unsaved changes', '@actions'),
					text: this.$tCaption('Do you really want to leave? you have unsaved changes!'),
					buttons: [{
						type: 'danger',
						text: this.$tCaption('Leave'),
						onClick: () => {
							next();
						}
					}, {
						text: this.$tCaption('Cancel'),
						onClick: () => {
							next(false);
						}
					}]
				});
			} else next();
		},
		methods: {
			getMarketSizes(pageIndex, limit, opts) {
				if (opts && opts.byKey)
					return this.$Data.getExternalApi('MarketSize/Get', `id=${opts.byKey}`).then(r => ({ Results: r }));
				return this.$Data.getExternalApi('MarketSize/List', `page=${pageIndex + 1}${this.$Data.getFilterCriteriaSortingParams(opts)}`, limit);
			},
			linkSelectedComputer() {
				this.$Data.postExternalApi('Service/LinkUnlink', {
					TargetObjectId: this.id,
					TargetObjectType: 0,
					TargetObjectCollectionFieldName: 'StationComputers',
					RelatedObjectIds: [
						this.selectedComputer.Oid
					],
					IsLinkAction: true
				});
				this.linkedComputer = this.selectedComputer;
				this.linkedComputerPopupVisible = false;
			},
			showLinkedComputersSelector() {
				this.linkedComputerPopupVisible = false;
				setImmediate(() => this.linkedComputerPopupVisible = true);
			},
			getEmptyComputers(pageIndex, limit, opts) {
				return this.$Data.getExternalApi('StationComputer/List', `filterCriteria=["Station.Oid", "=", null]&page=${pageIndex + 1}`, limit);
			},
			loadLinkedComputer() {
				if (this.id) {
					this.$Data.getExternalApi('StationComputer/List',`filterCriteria=["Station.Oid", "=","${this.id}"]`, 1).then(r => {
						this.linkedComputer = r.Results[0];
						this.isLinkedComputerLoaded = true;
					});
				}
			},
			loadDisclosure(force) {
				if (!force && (`${this.id}`.toLowerCase() === 'new' || this.disclosureLoaded)) return;
				if (__DEBUG__)
					console.debug('Load disclosure');
				this.isLoading = true;
				return this.$Data.getExternalApi('Station/GetStationAiDisclosure', `stationId=${this.station?.Oid}`).then(r => {
					this.disclosure = r;
					this.disclosureLoaded = true;
				}).finally(() => this.isLoading = false);
			},
			showDisclosure() {
				this.disclosureUrl = this.disclosure?.Url;
				this.$refs.disclosureUploader.showPopup();
			},
			onDisclosureChange(v) {
				if (!this.allowEdit) return;

				if (__DEBUG__)
					console.debug('On disclosure change', v);

				var fr = new FileReader;
				fr.readAsDataURL(v[0]);
				fr.onloadend = () => {
					const img = fr.result.split('base64,')[1];
					const dataType = v[0]?.name?.split('.').pop();
					this.isLoading = true;
					this.$Data.postExternalApi('Station/UploadAIDisclosureScreenshot', {
						Station: { Oid: this.station.Oid },
						Url: this.disclosureUrl,
						Screenshot: {
							Base64Content: img,
							FileExtension: dataType
						}
					}).then(r => {
						if (__DEBUG__)
							console.debug('Ai Disclosure uploaded', { r });
						this.$notifySuccess('Ai Disclosure has been succsessfully uploaded');
					}).finally(() => {
						this.isLoading = false;
						this.loadDisclosure(true);
					});
				};
			},
			onPhotoChange(v) {
				if (!this.allowEdit) return;

				if (__DEBUG__)
					console.log('On photo selected', v);

				var fr = new FileReader;
				fr.readAsDataURL(v[0]);
				fr.onloadend = () => {
					this.logoUrl = fr.result;
					var img = fr.result.split('base64,')[1];
					this.$Data.postExternalApi('Service/SetObjectImage', {
						ObjectId: this.station.Oid,
						ObjectType: 0,
						Base64Content: img
					}).then(r => {
						if (__DEBUG__)
							console.debug('Logo uploaded', { r });
					});
				};
			},
			setNew() {
				this.station = {
					Oid:null,
					Name:null,
					Description:null,
					CallLetters:null,
					Frequency:null,
					FccId:null,
					Slogan:null,
					Radius:null,
					Latitude:null,
					Longtitde:null,
					StationBand:null,
					Educational:null,
					Ethnicity:null,
					Male:null,
					Age:null,
					Phone:null,
					Website:null,
					Country: {
						Oid: this.$auth.countryId()
					},
					CountryRegion:null,
					County:null,
					Zone:null,
					DmaZone:null,
					MsaZone:null,
					Network:null,
					SecondaryNetwork:null,
					Formats:null,
					MarketSize: null
				};
			},
			setLogo(preventRand) {
				var url = this.$Data.getMethodUrl(`externalApi?accessToken=${this.$auth.accessToken()}&method=Station/GetStationImage&parameters=${encodeURIComponent(`stationId=${this.station.Oid}`)}`);
				this.logoUrl = this.station.HasImage ? `${url}${!preventRand ? `&ver=${Math.random()}` : ''}` : null;
			},
			loadData() {
				if (!this.id || `${this.id}`.toLowerCase() === 'new') {
					this.setNew();
				} else {
					this.isLoading = true;
					return this.$Data.getExternalStations(void 0, void 0, { byKey: this.id }).then((r) => {
						if (__DEBUG__)
							console.debug('Station loaded', { r });
						this.station = r && r.Results && r.Results[0];
						this.setLogo();
					}).finally(() => this.isLoading = false);
				}
			},
			setStationLatLng() {
				if (!this.allowEdit) return;
				setImmediate(() => {
					if (this._isDestroyed) return;
					if (this.station.Latitude && this.station.Longtitde && this.station.Radius && this.$refs.map) {
						this.setMapView(this.station.Latitude, this.station.Longtitde, this.station.Radius * 1000);
						setTimeout(() => {
							if (this._isDestroyed) return;
							if (this.$refs.map)
								this.$refs.map.fitDrawnItems();
						}, 200);
					}
				});
			},
			save(e) {
				if (!e.validationGroup.validate().isValid) {
					return;
				}
				if (this.isSaving || this.isLoading || !this.allowEdit) return;
				if (__DEBUG__)
					console.debug('Saving', this.isSaving);
				this.isSaving++;
				this.isLoading++;
				return this.$Data
					.postExternalApi(
						'Station/CreateUpdateStation',
						{ ...this.station }
					)
					.then(r => {
						if (this._isDestroyed) return;
						if (r.Success) {
							this.$notifySuccess('Data saved');
							this.station = r.Data;
							setImmediate(() => {
								if (this._isDestroyed) return;
								this.dataChanged = false;
							});

							if (this.id === 'new') {
								this.isLoading++;
								this.isSaving++;
								this.$Data
									.postExternalApi(
										'Company/AddStationsToCompany',
										{
											ObjectId: this.$auth.companyId(),
											ItemIds: [this.station.Oid]
										}
									)
									.finally(() => {
										this.isLoading--;
										this.isSaving--;
										this.$emit('created', this.station);
										if (!this.preventRedirect)
											this.$router.push({ path: `/station/Detail/${this.station.Oid}` });
									});
								this.setLogo();
							}
						} else {
							this.$notifyError(r.ErrorMessage);
						}
					})
					.finally(() => {
						this.isLoading--;
						this.isSaving--;
					});
			},
			deleteStation() {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text:  this.$tCaption('Are you sure you want to delete station?'),
					handler: () => {
						this.isLoading = true;
						this.$Data.getExternalApi('Station/DeleteStation', `stationId=${this.station.Oid}`).then(r => {
							if (r.Success) {
								this.$notifySuccess(this.$tCaption('Station deleted'));
								this.$router.push({ path: '/station/List' });
							} else {
								this.$notifyError(r.ErrorMessage);
							}
						}).finally(() => {
							if (this._isDestroyed) return;
							this.isLoading = false;
						});
					}
				});
			},
			onPlaceChanged(data) {
				if (!this.allowEdit) return;
				var locData = { lat: data.lat, lng: data.lng, radius: 91800 };
				this.setLatLngRadius(locData);
			},
			onFilterChanged(type, data) {
				if (!this.allowEdit) return;
				this.circleDrawings = [];
				if (data) {
					this.setLatLngRadius(data);
				}
			},
			setMapView(lat, lng, radius) {
				this.$refs.map.clearFilters();
				this.circleDrawings =[{
					lat,
					lng,
					radius,
					fillOpacity: 0.1
				}];
			},
			setLatLngRadius(data) {
				if (!this.allowEdit) return;
				if (this.station) {
					this.station.Latitude = data.lat;
					this.station.Longtitde = data.lng;
					if (!this.station.Radius || data.radius > 5000)
						this.station.Radius = Math.round(data.radius / 100) / 10;
				}
			}
		}
	};
</script>

<style lang='scss'>
	.station-detail {
		.header-data {
			margin: 10px;
		}

		.left-items {
			min-width: 340px;
		}

		.edit {
			margin-left: 20px;
		}

		.station-map {
			border-radius: 20px;
			overflow: hidden;
			height: 33vh;
			min-height: 240px;
		}

		.station-block {
			background: rgba(255, 255, 255, 0.5);
			padding: 10px;
		}

		.station-image {
			max-height: 100px;
			max-width: 180px;
			height: 100px;
		}

		.disclosure-image {
			max-width: 960px;
			max-height: 640px;
		}
	}
</style>
